<div class="success-container">
  <div class="success-container__body">
    <i class="icon-check-img icon-48"></i>
    <span class="success-container__bodyText">Thank you for sharing your feedback with us!</span>
  </div>
  <i (click)="onCloseModal()" class="icon-close icon-16"></i>
</div>
